'use client'

import { useWallet } from '@/providers/WalletContext'
import { useModalStore } from '@/stores/modal-store'
import { usePrivy } from '@privy-io/react-auth'
import { useCallback } from 'react'

/**
 * Auth state + actions facade. Components use this instead of importing
 * @privy-io/react-auth directly (wallet-core boundary rule).
 */
export function useAuthSession() {
	const { ready, user, logout: privyLogout } = usePrivy()
	const { authenticated } = useWallet()
	const openModal = useModalStore(s => s.openModal)

	// External-wallet users now log in via Privy's native SIWE, so Privy owns
	// the whole session — logout just delegates to it (no JWT store to clear).
	const logout = useCallback(async () => {
		await privyLogout()
	}, [privyLogout])

	return {
		ready,
		authenticated,
		userId: user?.id,
		email: user?.email?.address ?? user?.google?.email ?? undefined,
		logout,
		openAuthDialog: () => openModal('auth'),
	}
}
